<app-navbar
  [logo]="logo"
  [logoName]="logoName"
  [logoLink]="logoLink"
  [links]="links"
  [logoSlogan]="logoSlogan"
  [logoSloganMobile]="logoSloganMobile"
></app-navbar>
<ng-content></ng-content>
<app-footer-navbar
  [logo]="logo"
  [logoName]="logoName"
  [logoSlogan]="logoSlogan"
  [logoSloganMobile]="logoSloganMobile"
  [logoLink]="logoLink"
  [copyright]="copyRightInfo"
></app-footer-navbar>
